@if (placeOrderError) {
  <section class="error-container">
    <div style="width: 100%;"><kendo-svg-icon [icon]="icons.exclamationCircleIcon"/></div>
    <h1>{{ 'attention'  | translate }}</h1>
    <h4>{{ 'bookingHandler.orderError' | translate }}</h4>
  </section>
} @else {
  @if (!hidePriceState) {
    <app-price-state/>
    <app-spacer/>
  }
  @if (contractId && ndc && checkoutId) {
    <app-payment-form
      [contractId]="contractId"
      [checkoutId]="checkoutId"
      [ndc]="ndc">
    </app-payment-form>
  } @else {
    <div style="
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;">
      <kendo-circularprogressbar
        style="height: 180px; width: 180px;"
        [progressColor]="'#79b6ff'"
        [indeterminate]="true"
        [value]="25">
      </kendo-circularprogressbar>
    </div>
  }
}
